import { getApiRequest } from 'utils/fetch-helper'

export async function checkCouponAvailability({
    coupon_code,
    membership_id = '',
    service_id = '',
    email = '',
} : {
    coupon_code: string
    membership_id?: string
    service_id?: string
    email?: string
}) {
    const query_params: string[] = [
        `couponCode=${encodeURIComponent(coupon_code)}`,
        `email=${encodeURIComponent(email)}`,
        `serviceId=${service_id}`,
        `membershipId=${membership_id}`
    ]
    return await getApiRequest(
        `/v1/coupons/check-coupon-availability-with-email?${query_params.join(
            '&'
        )}`
    )
}

